//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import base64 from 'base-64';
import dateFormat from 'dateformat';
import TagManager from 'react-gtm-module';

//components
import Lista from '../childrens/lista/.mixins/Lista';
import ModalRemove from "../childrens/modal_remove/.mixins/Modal_Remove";
import Alerta from "../../snackbars/.mixins/";

//controllers
import Comunicado_controller from '../../../../controllers/comunicado';
import Contato_controller from '../../../../controllers/contato';
import Grupo_controller from '../../../../controllers/grupo';
import Config from '../../../../controllers/config';
import Log from '../../../../controllers/log';

//childrens
import Columns from '../childrens/columns/.mixins';
import CustomToolbar from '../childrens/customToolbar/.mixins';

export default class Comunicados_contatos_lista extends Component {

    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.inputRef = React.createRef();

        this.state = {
            title: props.route.title+'s',
            itens: [],
            itensTable: [],
            columns: [],
            customToolbar: null,
            isLoading: true,
            isError: false,
            error: null
        }

        this.loadData = this.loadData.bind(this);
        this.setState = this.setState.bind(this);
        this.handleAdicionar = this.handleAdicionar.bind(this);
        this.checkRoute = this.checkRoute.bind(this);

    }

    UNSAFE_componentWillMount() {
        this.setState({
            customToolbar:() => <CustomToolbar {...this}/>,
        });
    };

    componentDidMount() {
        this.loadData(null);

        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:comunicado',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-comunicado',
        //     }
        // });

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        Log.info(token,"Efetuado carregamento da tela lista de "+this.props.route.title+"s!");
    }

    handleAdicionar() {
        this.props.router.push(`/${this.props.route.title}s-ae`);
    }

    checkRoute(value) {
        if (value['dir']!=null && value['dir'].includes(';@Assets')) {
            TagManager.dataLayer({
                dataLayer: {
                  event: 'event',
                  eventCategory: `tokstok:fornecedores:${this.props.route.title}`,
                  eventAction: 'clique:visualizar',
                  eventLabel: `arquivo-${this.props.route.title}-${value['id']}`,
                }
            });
            this.props.router.push(`${value['route']}s/arquivos/${value['id']}`);
        } else {
            TagManager.dataLayer({
                dataLayer: {
                  event: 'event',
                  eventCategory: `tokstok:fornecedores:${this.props.route.title}`,
                  eventAction: 'clique:visualizar',
                  eventLabel: `arquivo-${this.props.route.title}-${value['dir']}`,
                }
            });
            window.open(value['dir'], '_blank');
        }

    }

    returnLink(value) {
        if (value['dir']!=null && value['dir'].includes(';@Assets')) {
            TagManager.dataLayer({
                dataLayer: {
                  event: 'event',
                  eventCategory: `tokstok:fornecedores:${this.props.route.title}`,
                  eventAction: 'clique:visualizar',
                  eventLabel: `arquivo-${this.props.route.title}-${value['id']}`,
                }
            });

            return `${value['route']}s/arquivos/${value['id']}`;
        } else {
            TagManager.dataLayer({
                dataLayer: {
                  event: 'event',
                  eventCategory: `tokstok:fornecedores:${this.props.route.title}`,
                  eventAction: 'clique:visualizar',
                  eventLabel: `arquivo-${this.props.route.title}-${value['dir']}`,
                }
            });

            return value['dir'];
        }
    }

    async loadData(filters) {

        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            
            var r_dados = null;
            this.setState({
                itens: [],
                itensTable: [],
                columns: [],
                isLoading: true,
            });

            var colunas = Columns(this);
            
            if (this.props.route.title == 'comunicado')
                r_dados = await Comunicado_controller.getTable(token,filters);
            else if (this.props.route.title == 'contato')
                r_dados = await Contato_controller.getTable(token,filters);

            const j_r_dados = JSON.parse(r_dados.body);
            
            if (r_dados.res.statusCode == 200) {

                //caso for contatos
                if (this.props.route.title == 'contato') {
                    colunas.unshift("Grupos");

                    const r_groups = await Grupo_controller.get(token);
                    var j_r_grupos = JSON.parse(r_groups.body);
                    if (r_groups.res.statusCode != 200) {
                        this.props.child.current.retorno('Erro ao carregar dados!','error');
                    }

                } 
                //caso for comunicados
                else {
                    // insere campos de data vigencia
                    var dtIni = {
                        name: "Início Vigência",
                        options: {
                            filter: false,
                            download: true,
                            display: true,
                            customBodyRender: (value, tableMeta, updateValue) => (
                                value
                            )
                        }
                    };

                    var dtFim = {
                        name: "Fim vigência",
                        options: {
                            filter: false,
                            download: true,
                            display: true,
                            customBodyRender: (value, tableMeta, updateValue) => (
                                value
                            )
                        }
                    };

                    colunas.splice(2,0,dtIni);
                    colunas.splice(3,0,dtFim);
                }

                //prepara dados para tabela
                var arrayItens = [];
                var arrayIntern = [];
                j_r_dados.itens.forEach(element => {
                    arrayIntern = [
                        element.titulo,
                        element.descricao,
                        this.returnLink({ id:element.id, route: this.props.route.title, dir:element.diretorio }),
                        { id:element.id, route: this.props.route.title, dir:element.diretorio },
                        { link: this.props.route.path, id: element.id }
                    ];

                    //caso for contatos
                    if (this.props.route.title == 'contato') {
                        var gs = j_r_grupos.itens.find(x => x.id == element.grupo_id);
                        if (gs)
                            arrayIntern.unshift(gs.descricao);
                        else
                            arrayIntern.unshift("?");
                    } 
                    //caso for comunicados
                    else {
                        //add dts de vigencia
                        var dtIni = element.lancamento.split(" ");
                        var dtFim = element.termino.split(" ");

                        arrayIntern.splice(2,0,dtIni[0]);
                        arrayIntern.splice(3,0,dtFim[0]);
                    }

                    arrayItens.push(arrayIntern);
                });

                this.setState({
                    itens: j_r_dados.itens,
                    itensTable: arrayItens,
                    isLoading: false,
                    columns: colunas
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //         event: `event`,
                //         eventCategory: `tokstok:fornecedores:${this.props.route.title}`,
                //         eventAction: 'callback',
                //         eventLabel: `sucesso:lista-${this.props.route.title}`,
                //     }
                // });

            } else {
                if (
                    r_dados.res.statusCode == 200 &&
                    j_r_dados.message &&
                    j_r_dados.message.includes("Token inválido!")
                ) {
                    this.props.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }

            //auditoria
            var str = "Efetuada requisição para recuperação de dados de "+this.props.route.title+"s! "
            +"Response:( Method: "+r_dados.res.request.method
            +", StatusCode: "+r_dados.res.statusCode
            +", Body: (limited 100chars)"+r_dados.body.substr(0,100)
            +" )";
            Log.info(token,str);
        } catch (error) {
            console.error(error);
            this.props.child.current.retorno('Erro ao carregar dados!','error');
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //         event: `event`,
            //         eventCategory: `tokstok:fornecedores:${this.props.route.title}`,
            //         eventAction: 'callback',
            //         eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            var str = "Erro ao recuperar dados de "+this.state.title+"s! "
            +"Erro:( Message: "+error.message+", Stack: "+error.stack+" )";
            Log.error(token,str);
        }

    }

    render() {
        return (
            <div>
                <Lista {...this}/>
                <Alerta ref={this.child}/>
                <ModalRemove ref={this.inputRef} pai={this}/>
            </div>
        );
    }

}